import 'css-chunk:src/app/containers/MemberDetail/components/MemberDetails/components/ApplicationData/ApplicationData.scss';export default {
  "noFields": "_noFields_12jm9_1"
};